import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React from 'react'

import * as SC from './CartModalEmpty.style'

export interface ICartModalEmptyProps {
  onClose: () => void
}

export const CartModalEmpty = ({ onClose }: ICartModalEmptyProps) => {
  const t = useStaticText()

  return (
    <SC.Wrapper>
      <SC.Label>{t.shopping_cart.no_items}</SC.Label>
      <SC.ButtonSecondary onClick={onClose}>{t.shopping_cart.continue_shopping}</SC.ButtonSecondary>
    </SC.Wrapper>
  )
}
